import { type InboundEmitMessage } from './types';

export const replyToMessage = (messageEvent: { data: InboundEmitMessage } & MessageEvent, payload: any) => {
  const { origin, source, data } = messageEvent;

  (source as Window).postMessage(
    {
      messageId: data.messageId,
      payload,
    },
    origin,
  );
};
